<iw-info-dialog-content
  status="failed"
  iconName="warning"
  [title]="'vpnCheckDialog.title' | translate"
>
  <div afterTitle>
    <p class="subtitle d-flex justify-center">
      {{ "vpnCheckDialog.message" | translate }}
    </p>
    <div class="actions">
      <iw-button
        size="m"
        fullWidth
        class="action"
        uiType="primary"
        (click)="close()"
      >
        {{ "vpnCheckDialog.btn.close" | translate }}
      </iw-button>
    </div>
  </div>
</iw-info-dialog-content>
